(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type') || 'none';
      this.enableSticky = this.stickyType !== 'none';
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};
      this.forceSolid = false;

      if (this.header) {
        this.setHeaderHeight();
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
        window.addEventListener('resize', this.setHeaderHeight.bind(this), { passive: true });
        // Re-measure after layout settles (fonts / announcement content).
        requestAnimationFrame(() => this.setHeaderHeight());
      }

      if (this.enableSticky) {
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      if (this.hasAttribute('data-transparent')) {
        this.initTransparent();
      }
    }

    setHeaderHeight() {
      // Measure the sticky-header itself — .section-header collapses to 0 when
      // the header is position:absolute (transparent/homepage templates).
      const height = this.offsetHeight || this.header?.offsetHeight || 0;
      if (height > 0) {
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    }


    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.onTransparentScroll) {
        window.removeEventListener('scroll', this.onTransparentScroll);
      }
      if (this.onForceSolid) {
        window.removeEventListener('quiz-header-solid', this.onForceSolid);
      }
      if (this.menuDetails && this.onMenuToggle) {
        this.menuDetails.removeEventListener('toggle', this.onMenuToggle);
      }
    }

    initTransparent() {
      this.onTransparentScroll = this.updateTransparent.bind(this);
      this.onForceSolid = () => {
        this.forceSolid = true;
        this.updateTransparent();
      };
      this.onMenuToggle = this.updateTransparent.bind(this);

      window.addEventListener('scroll', this.onTransparentScroll, { passive: true });
      window.addEventListener('quiz-header-solid', this.onForceSolid);
      this.menuDetails = this.querySelector('#Details-menu-drawer-container');
      if (this.menuDetails) {
        this.menuDetails.addEventListener('toggle', this.onMenuToggle);
      }

      this.updateTransparent();
      this.setHeaderHeight();
    }

    updateTransparent() {
      const menuOpen = Boolean(this.menuDetails && this.menuDetails.open);
      const solid = this.forceSolid || menuOpen || window.pageYOffset > 65;
      this.classList.toggle('header-is-solid', solid);
      this.classList.toggle('is-not-sticky', !solid);
      this.classList.toggle('as-bg-[transparent]', !solid);

      const utilityBar = this.querySelector('#utility-bar');
      if (utilityBar) {
        utilityBar.classList.toggle(
          'utility-bar-background',
          !solid && !document.body.classList.contains('quiz-active')
        );
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }



      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

  }

  customElements.define('sticky-header', StickyHeader);



  } catch(e) { console.error(e); }
})();
})();
